/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */




 $(function() {

   function announcement_height() {
    var height = 0;

    if( $('#section-announcement').length > 0 && $('#section-announcement').hasClass('announcement-bar-fixed')) {
      height = Math.floor($('#section-announcement').height());
    }

    if( height !== 0 && $('#shopify-section-announcement').length > 0 ) {
        $('#shopify-section-announcement').css('height', height + 'px' );
    }

    return height;
   }

   function announcement_height_gbp() {
    var height = 0;

    if( $('#section-announcement_gbp').length > 0 && $('#section-announcement_gbp').hasClass('announcement-bar-fixed')) {
      height = Math.floor($('#section-announcement_gbp').height());
    }

    if( height !== 0 && $('#shopify-section-announcement_gbp').length > 0 ) {
        $('#section-announcement_gbp').css('height', height + 'px' );
    }

    return height;
   }

   if ( announcement_height() > 0 ) {
     jQuery('#shopify-section-header').animate({ 'top':announcement_height() }, 300 );
   }

   if ( announcement_height_gbp() > 0 ) {
     jQuery('#shopify-section-header_gbp').animate({ 'top':announcement_height_gbp() }, 300 );
   }

   $(window).resize( function() {
     if ( announcement_height() > 0 ) {
       jQuery('#shopify-section-header').animate({ 'top':announcement_height() }, 300 );
     }

     if ( announcement_height_gbp() > 0 ) {
      jQuery('#shopify-section-header_gbp').animate({ 'top':announcement_height_gbp() }, 300 );
     }
   })


     $(document).on('click', '.product-modal', function (e) {
         e.preventDefault();
         $.fancybox.close();
         var url = $(this).attr('data-link');
         if( ! url ) {
             url = $(this).attr('href');
         }

         if(window.location.href.split("?").length >= 2 ){
             let href = window.location.href.split("?")[0];
             window.history.pushState({href: href}, '', href);
         }

         if (url) {
             $.fancybox.open(
                 {
                     src: url,
                     opts: {
                         type: 'ajax',
                         smallBtn: false,
                         baseClass: "fancybox-skin",
                         touch: false,
                         afterLoad: function (instance, current) {
                             setTimeout(function () {
                                 $(document).find('.fancybox-content').scrollTop(0);
                             }, 427);
                         },
                         beforeClose: function( e, instance ) {
                             if ( typeof window.languages.productFormAddToCartMain != 'undefined' ) {
                                 window.languages.productFormAddToCart = window.languages.productFormAddToCartMain;
                             }
                         }
                     }
                 }
             );
         }
         return false;
     });
 });

 window.addEventListener('load', function () {
  let name = 'cookie-banner';
  let value = 'cookie-banner';
  let days = 90;
  let domain = document.domain;
  let cookieBanner = getCookie(name);

  // Use setInterval to check if customerPrivacy is defined
  let interval = setInterval(function () {
    if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.shouldShowBanner === 'function') {
      clearInterval(interval); // Stop checking once it's defined

      if (!cookieBanner && window.Shopify.customerPrivacy.shouldShowBanner() == false) {
        displayCookieBanner();
      }
    }
  }, 100); // Check every 100ms

  var cookie_element = document.getElementById('cookie-banner-close')
  if (cookie_element) {
      cookie_element.addEventListener('click', function (event) {
          event.preventDefault();
          if (!cookieBanner) {
              setCookie(name, value, days, domain);
          }
          hideCookieBanner();
      });
  }

  function hideCookieBanner() {
      document.getElementsByClassName('cookie-banner')[0].style.display = 'none';
  }

  function displayCookieBanner() {
      document.getElementsByClassName(name)[0].style.display = 'flex';
  }

  function setCookie(name, value, days, domain) {
      let expires = "";
      let date = new Date();
      if (days) {
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
          expires = "; expires=" + date.toGMTString();
      }

      if (domain) {
          document.cookie = name + "=" + value + expires + "; path=/; domain=" + domain;
      } else {
          document.cookie = name + "=" + value + expires + "; path=/";
      }
  }

  function getCookie(name) {
      let nameEQ = name + "=";
      let ca = document.cookie.split(';');

      for (let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') c = c.substring(1, c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }

      return null;
  }

});



document.addEventListener("click", function (e) {
  const link = e.target.closest("a");

  if (!link) return;

  // only target filter links
  if (link.href.includes("filter") || link.href.includes("constraint")) {
    e.preventDefault();
    window.location.href = link.href; // force navigation
  }
});

document.addEventListener("DOMContentLoaded", function () {
  initLoadMore();
});

document.addEventListener("DOMContentLoaded", function () {

  let currentPage = 1;

  function getTotalPages() {
    const items = document.querySelectorAll(".custompaginate");

    if (!items.length) return 1;

    return Math.max(...[...items].map(el => {
      const match = el.className.match(/paginate-(\d+)/);
      return match ? parseInt(match[1]) : 1;
    }));
  }

  // hide all except first page
  document.querySelectorAll(".custompaginate").forEach(el => {
    if (!el.classList.contains("paginate-1")) {
      el.style.display = "none";
    }
  });

  // button click only
  document.addEventListener("click", function (e) {

    const btn = e.target.closest("#LoadMoreBtn");

    if (!btn) return;

    e.preventDefault();

    currentPage++;

    document.querySelectorAll(".paginate-" + currentPage).forEach(el => {
      el.style.display = "inline-block";
    });

    if (currentPage >= getTotalPages()) {
      btn.style.display = "none";
    }
  });

});

document.addEventListener("change", function (e) {
  const input = e.target;

  if (!input.matches('input[name^="filter."]')) return;

  const params = new URLSearchParams();

  document.querySelectorAll('input[name^="filter."]:checked').forEach(input => {
    params.append(input.name, input.value);
  });

  const newUrl = window.location.pathname + "?" + params.toString();

  window.history.replaceState({}, "", newUrl);
});

document.addEventListener("click", function (e) {
  const removeLink = e.target.closest('.remove-filter');

  if (!removeLink) return;

  e.preventDefault();

  const url = removeLink.getAttribute("href");

  if (url) {
    window.history.replaceState({}, "", url);

    window.location.href = url;
  }
});